import { component } from 'picoapp';
import Swiper from 'swiper';
import ProductItem from '../../js/lib/product-item';
import app from '../app';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const output = node.querySelector('.js-output');
  const sliderElement = node.querySelector('.js-slider');

  /**
   * Functions
   */
  const getProducts = () => new Promise((resolve) => {
    const handles = localStorage.getItem('viewedProducts')?.split(',') || [];

    if (handles.length) {
      const fetches = handles.map((handle, index) => fetch(`/products/${handle}.json`).then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        // If product has been removed from shop, remove it from localStorage as well
        handles.splice(index, 1);
        localStorage.setItem('viewedProducts', handles);
        return null;
      }).then(async (data) => {
        const product = data?.product || null;

        if (!product) {
          return null;
        }

        // Ajax product JSON does not include metafields; load material from the Liquid data view.
        try {
          const materialResponse = await fetch(`/products/${handle}?view=data`);

          if (materialResponse.ok) {
            const material = await materialResponse.json();
            product.material_mobile = material.material_mobile || '';
            product.material_desktop = material.material_desktop || '';
          }
        } catch (error) {
          // Keep the card if the data view is unavailable.
        }

        return product;
      }));

      Promise.all(fetches).then((data) => {
        // Only return actual data items (i.e. ones that are !== null)
        resolve(data.filter((item) => item));
      });
    } else {
      resolve(handles);
    }
  });

  const getMarkup = (products) => products.map((product) => `<li class="product-slider__item swiper-slide">
      ${ProductItem(product)}
    </li>`).join('');

  const init = async () => {
    const products = await getProducts();

    if (products.length) {
      output.innerHTML = getMarkup(products);

      // Mount productMedia on injected cards (inner Swiper, hover swap, deferred media).
      app.mount();

      (() => new Swiper(sliderElement, {
        slidesPerView: 'auto',
        grabCursor: true,
      }))();
    } else {
      node.remove();
    }
  };

  /**
   * Init
   */
  init();
});
